<div class="error-message-container">
    <h2 class="error-message-container__header">We're sorry, an error occurred.</h2>
    <p class="error-message-container__text">
        It looks like something went wrong on our end.<br />
        Please try again later or call
        <span class="error-message-container__phone-number">
            <a href="tel:{{ nonPdgPhoneNumber }}">{{ nonPdgPhoneNumber }}</a>
        </span>
        for assistance.
    </p>
</div>
